(function ($) {
  //
  //    METHOD OVERVIEW
  //
  //      init:
  //            Move filter tab to correct position
  //            Move filter panel to correct position
  //            Event handlers
  //
  //      adjustMppProductHeights:
  //            Look at the height of all the visible products in each row
  //            and make them all the same height (using tallest in row as a guide)
  //
  //      populateConcernedArr:
  //            Create array of all filter possibilities based on product list (dry, oily, daywear, etc)
  //
  //      filterProducts:
  //            Based on selected filters, decide which products to display
  //
  //      createZeroProductFilterMatrix:
  //            Create a [filter1][filter2] matrix that returns TRUE if there are ZERO products with both those filters
  //
  //      greyOutZeroResultFilters:
  //            Based on chosen filters, decide which filters, if selected, would result in zero products,
  //            and grey out those filters
  //
  //      getClassFromFilterLineItem:
  //            Given a filter line item DOM element, get its filter class, e.g., dry, normal_combination, etc
  //
  //      setVisibleItemCount:
  //            Display number of visible products
  //
  //      createSecondColumnForAttributesIfNeeded:
  //            If an attribute has too many filters in a single column, move the extra filters to a second column
  //
  //      adjustColumnWidths:
  //            Based on the number of attributes and the number of columns in each attribute,
  //            adjust the width of those attributes and the columns in them.
  //
  //      adjustMppProductGrid:
  //            The current grid adds a special class to those products in the middle of a row,
  //            which works unless they're not in the middle of a row anymore. This function
  //            sees what's in the middle, and gives that product a special class.
  //

  site.mpp_filter = {
    isIE: $('html').data('useragent').indexOf('MSIE') > -1,
    zeroProductFilterMatrix: {},
    lastFilterClicked: {
      name: '',
      selected: true
    },

    //
    //    TERMS:
    //      Attribute: category of filter option.
    //        Examples: Skin Type, Skin Concern, Collection
    //
    //      Filter option: specific option within an attribute
    //        Examples:
    //          "Dry" and "Normal" filter options in the Skin Type attribute
    //          "DayWear" and "Hydrationist" filter options in Collection attribute

    //    Use OR within an attribute (like Skin Type)
    //        So users can choose "Dry" "Normal" and "Oily"
    //        and that INCREASES the number of visible products
    //
    //    Use AND between attributes
    //        If a user chooses, say, "Dry" and "Normal" skin types, then
    //        certain filter options in other attributes (like Skin Concern or Collections)
    //        will grey out.
    //

    maxNumberFiltersPerColumn: 7,

    lastAttributeWhereUserClickedAFilter: false,

    //
    //    Use this array to set which categories display the filter
    //
    allowedCatBaseIdsForFilter: [
      688, //  Moisturizers
      689 //  Serum
      // 685,  //  Eye Care
      // 637,  //  Mascara
      // 684,  //  Cleanser/Toner
      // 649,   //  Lipstick
      // 647,   // Lip gloss
      // 636,   // Eye Shadow
      // 643   // Foundation
    ], // use integers, not strings

    showSkinTypes: [688],
    showCollections: [688, 689, 685, 637, 684, 649, 643],
    showBenefits: [637, 684],
    showConcerns: [688, 689, 685],
    showFinishes: [643],
    showIntensity: [643],
    showCoverage: [643],
    thisCatId: null,
    concernArr: [],
    init: function () {
      //
      //    Make sure
      //      1.  filter exists on the page and
      //      2.  the current MPP should show it
      //
      thisCatId = page_data['catalog-mpp'].categories[0].CAT_BASE_ID;
      if (
        $('#mpp__filter').length === 0 ||
        $.inArray(thisCatId, site.mpp_filter.allowedCatBaseIdsForFilter) === -1
      ) {
        return false;
      }

      var $mppFilter = $('#mpp__filter');
      var $mppFilterTab = $('#mpp__filter-tab');
      var widthFilter = $mppFilter.outerWidth();
      var filterPos = $mppFilter.position();
      var filterTop = $mppFilter.css('top');
      var heightFilterTab = $mppFilterTab.outerHeight();
      var $allSections = $('#mpp__filter .mpp__filter-section');
      var newFilterTop;
      var widthFilterTab;

      //
      //    Sapce out products in MPP grid
      //
      site.mpp_filter.adjustMppProductGrid();

      //
      //  Move "Filter By" next to "Moisturizers" headline
      //
      $($mppFilterTab).detach().prependTo('.mpp.js-mpp-wrapper');

      //
      //  Move filter panel just above product grid
      //  and make it visible
      //
      $mppFilter.detach().insertBefore('.mpp__product-grid');

      //
      // Find out which filter items should be shown
      //
      site.mpp_filter.populateConcernedArr();
      site.mpp_filter.setVisibleItemCount();

      // show appropriate filters and hide the others
      $('.mpp__filter-content li.mpp__filter-item').addClass('js-inactive');
      for (var i = 0; i < site.mpp_filter.concernArr.length; i++) {
        $('.mpp__filter-content li.mpp__filter-item.' + site.mpp_filter.concernArr[i]).removeClass(
          'js-inactive'
        );
      }

      //  add hidden class to items who aren't available for this MPP's "default state"
      //  (i.e., when no filters are currently engaged)
      $('.mpp__filter-content li.mpp__filter-item.js-inactive').addClass('hidden');

      site.mpp_filter.zeroProductFilterMatrix = site.mpp_filter.createZeroProductFilterMatrix();

      //
      //    Remove attributes without options in them
      //
      //      Examples of attributes: Skin Type, Finish, Collection
      //
      //      In every attribute (i.e., ".mpp__filter-section"), see if there are any non-"js-inactive" filter items
      //      If they're all js-inactive, hide the attribute
      //
      $.each($allSections, function (index) {
        var numActiveFilters = $(this).find("li:not('.js-inactive')").length;

        if (numActiveFilters === 0) {
          $(this).remove();
        }
      });

      //
      //    Decide if any attributes have too many filters, and they need a second column
      //
      site.mpp_filter.createSecondColumnForAttributesIfNeeded();

      site.mpp_filter.adjustColumnWidths();

      //
      //  Move filter panel just above product grid and make it visible
      //
      $mppFilter.detach().insertBefore('.mpp__product-grid');

      // //////////////////////////////
      //                            //
      //  EVENT HANDLERS            //
      //                            //
      // //////////////////////////////

      //
      //    Click filter options
      //
      $('#mpp__filter li.mpp__filter-item a').on('click', function (e) {
        e.preventDefault();

        site.mpp_filter.scrollToTopOfFilter();

        //
        //  Ignore the click if the user's clicked on a greyed-out filter option
        //
        if ($(this).parents('.zero-results').length > 0) {
          return false;
        }

        //
        //    Remember which filter was clicked on most recently and
        //    See if filter is about to be displayed as "selected"
        //
        var isSelected = !$(this).find('.filter-item-checkbox.active').length;

        site.mpp_filter.lastFilterClicked = {
          name: site.mpp_filter.getClassFromFilterLineItem($(this).closest('li.mpp__filter-item')),
          selected: isSelected
        };

        //
        //    For analytics
        //
        //      Should create something like this: "Skincare|Moisturizers|Skin Concern|Loss of Firmness"
        //
        if (
          tms_page_data &&
          tms_page_data['tms_page_info'] &&
          tms_page_data['tms_page_info']['page_name']
        ) {
          var pageNameArr = tms_page_data['tms_page_info']['page_name']['pageID'].split(' | ');
          var hierarchy1 = pageNameArr[2];
          var hierarchy2 = pageNameArr[4];
          var hierarchy3 = (categoryName = $(this)
            .closest('.mpp__filter-section')
            .find('h2')
            .text());
          var filterName = $(this).find('.filter-name').text();

          $(this).trigger('MPP:FILTERCLICK', [
            hierarchy1 + '|' + hierarchy2 + '|MPP Filter-' + hierarchy3 + '|' + filterName
          ]);
        }

        //
        //  See which attribute the user clicked inside
        //
        $thisAttribute = $(this).closest('.mpp__filter-section');
        site.mpp_filter.lastAttributeWhereUserClickedAFilter =
          $('.mpp__filter-section').index($thisAttribute);

        // Make filter and checkbox active
        $(this).toggleClass('active').find('.filter-item-checkbox').toggleClass('active');

        site.mpp_filter.filterProducts();
        site.mpp_filter.greyOutZeroResultFilters();
        site.mpp_filter.adjustMppProductHeights(); // make sure all visible products in a row have same height
        site.mpp_filter.adjustMppProductGrid();
        site.mpp_filter.setVisibleItemCount();

        //
        //  Update "Clear all" button, if necessary
        //
        var $clearAll = $mppFilter.find('.clear-all');

        if ($mppFilter.find('li.mpp__filter-item a.active').length === 0) {
          $clearAll.removeClass('filter-selected');
        } else {
          if (!$clearAll.hasClass('filter-selected')) {
            $clearAll.addClass('filter-selected');
          }
        }
      });

      //
      //    Click Filter tab
      //
      $mppFilterTab.on('click', function (evt) {
        site.mpp_filter.scrollToTopOfFilter();

        if ($mppFilter.css('display') == 'none') {
          $mppFilter.slideDown();
          $mppFilterTab.find('.plus').fadeOut('fast', function () {
            $mppFilterTab.find('.minus').fadeIn('fast').css('display', 'inline-block');
          });
        } else {
          $mppFilter.slideUp();
          $mppFilterTab.find('.minus').fadeOut('fast', function () {
            $mppFilterTab.find('.plus').fadeIn('fast').css('display', 'inline-block');
          });
        }
      });

      //
      //    Hover over "Clear All"
      //
      //      We're using a class instead of ":hover" in CSS
      //      because ":hover" causes a problem in iPad
      //
      $('#mpp__filter-footer .clear-all').on('hover',
        function () {
          $(this).addClass('hover');
        },
        function () {
          $(this).removeClass('hover');
        }
      );

      //
      //  Click "Clear All"
      //
      //    Click all active (selected) filters, which should unselect them
      //
      $('#mpp__filter-footer .clear-all').on('click', function () {
        var $activeLinks = $('li.mpp__filter-item a.active');

        $activeLinks.each(function () {
          $(this).trigger('click');
        });
        $(this).removeClass('hover'); // fixing iPad bug where "hover" gets added back
      });
    },

    //
    //  Look at the height of all the visible products in each row
    //  and make them all the same height (using tallest in row as a guide)
    //
    adjustMppProductHeights: function () {
      var numProductsInRow = 3;
      var $visibleProducts = $('.mpp__product-grid li.mpp__product').not('.hidden');
      var numVisibleProducts = $visibleProducts.length;
      var maxRowHeight = 0;
      var counter = 0;
      var productHeight;

      // loop over all visible products
      for (i = 0; i < numVisibleProducts; i++) {
        productHeight = $visibleProducts.eq(i).css('height');
        productHeight = Number(productHeight.replace('px', ''));

        if (productHeight > maxRowHeight) {
          maxRowHeight = productHeight;

          if (counter === 1) {
            $visibleProducts.eq(i - 1).css('height', maxRowHeight + 'px');
          } else if (counter === 2) {
            $visibleProducts.eq(i - 1).css('height', maxRowHeight + 'px');
            $visibleProducts.eq(i - 2).css('height', maxRowHeight + 'px');
          }
        } else {
          $visibleProducts.eq(i).css('height', maxRowHeight + 'px');
        }
        counter++;
        if (counter === numProductsInRow) {
          counter = 0;
          maxRowHeight = 0;
        }
      }
    },

    populateConcernedArr: function () {
      var allSkinTypes = [];
      var skintypes = [];

      //
      //   Loop over all visible products in the MPP list
      //
      $('ul.mpp__product-grid li.mpp__product[data-productid]')
        .not('.hidden')
        .each(function (j, prodBox) {
          //
          //   Get product data from page_data
          //
          var prodId = $(prodBox).attr('data-productid');
          var product = $(page_data['catalog-mpp'].categories[0].products).filter(function () {
            return this.PRODUCT_ID === prodId;
          })[0];

          if (typeof product == 'undefined') {
            return true;
          }

          //
          // Add SKIN CONCERN
          //
          //    These appear as comma-separated strings, like "Lines and Wrinkles,Uneven Skintone,Blemishes,Enlarged Pores"
          //
          if (
            product.ATTRIBUTE_CONCERN !== null &&
            product.ATTRIBUTE_CONCERN !== 'undefined' &&
            $.inArray(thisCatId, site.mpp_filter.showConcerns) > -1
          ) {
            skinConcerns = product.ATTRIBUTE_CONCERN.split(',');

            $.each(skinConcerns, function (index, value) {
              skinConcernFormatted = value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
              $(prodBox).addClass(skinConcernFormatted);
              if ($.inArray(skinConcernFormatted, site.mpp_filter.concernArr) == -1) {
                site.mpp_filter.concernArr.push(skinConcernFormatted);
              }
            });
          }

          //
          // Add SKIN TYPES
          //
          //    These appear as comma-separated strings, like "Normal/Combination, Dry, Oily"
          //
          if (
            product.ATTRIBUTE_SKINTYPE !== null &&
            $.inArray(thisCatId, site.mpp_filter.showSkinTypes) > -1
          ) {
            skintypes = product.ATTRIBUTE_SKINTYPE.split(',');

            $.each(skintypes, function (index, value) {
              skinTypeFormatted = value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
              $(prodBox).addClass(skinTypeFormatted);
              if ($.inArray(skinTypeFormatted, site.mpp_filter.concernArr) == -1) {
                site.mpp_filter.concernArr.push(skinTypeFormatted);
              }
            });
          }

          //
          // Add BENEFITS
          //
          if (
            product.ATTRIBUTE_BENEFIT !== null &&
            $.inArray(thisCatId, site.mpp_filter.showBenefits) > -1
          ) {
            var arr = product.ATTRIBUTE_BENEFIT.split(',');

            $.each(arr, function (index, value) {
              var val = value.replace(/^\s+|\s+$/g, ''); // trim() that works with IE8

              val = val.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
              $(prodBox).addClass(val);
              if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
                site.mpp_filter.concernArr.push(val);
              }
            });
          }

          //
          //  Add COLOR FAMILY
          //
          for (i = 0; i < product.skus.length; i++) {
            if (product.skus[i].ATTRIBUTE_COLOR_FAMILY !== null) {
              val = product.skus[i].ATTRIBUTE_COLOR_FAMILY.trim()
                .toLowerCase()
                .replace(/[^A-Za-z0-9_]/g, '_');

              // fix color mappings
              switch (val) {
                case 'natural_browns':
                  val = 'naturals_browns';
                  break;
                case 'violets_blues':
                  val = 'violets_blues';
                  break;
                case 'violets__blues':
                  val = 'violets_blues';
                  break;
                case 'violets___blues':
                  val = 'violets_blues';
                  break;
                case 'violets__berries':
                  val = 'violets_blues';
                  break;
                case 'violets___berries':
                  val = 'violets_blues';
                  break;
              }

              $(prodBox).addClass(val);
              if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
                site.mpp_filter.concernArr.push(val);
              }
            }
          }

          //
          //    Add FINISH
          //
          var thisProductFinishes = [];

          productSkusLength = product.skus.length;
          if (productSkusLength > 0) {
            for (i = 0; i < productSkusLength; i++) {
              // Make sure SKU's skin type is in the list for this category
              if ($.inArray(thisCatId, site.mpp_filter.showFinishes) !== -1) {
                thisProductFinishes.push(product.skus[i].FINISH);
              }
            }
          }
          // remove duplicate entries from skin type array
          thisProductFinishes = $(thisProductFinishes).filter(function (itm, i, a) {
            return (i = $.inArray(itm, a));
          });
          len = thisProductFinishes.length;
          for (i = 0; i < len; i++) {
            if ($.inArray(thisProductFinishes[i], site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(thisProductFinishes[i]);
            }
          }

          //
          //    Add INTENSITY
          //
          var thisProductIntensity = [];

          productSkusLength = product.skus.length;
          if (productSkusLength > 0 && $.inArray(thisCatId, site.mpp_filter.showIntensity) !== -1) {
            for (i = 0; i < productSkusLength; i++) {
              val = product.skus[i].INTENSITY.trim()
                .toLowerCase()
                .replace(/[^A-Za-z0-9_]/g, '_');
              thisProductIntensity.push(val + '_intensity');
            }
          }
          // remove duplicate entries from intensity array
          thisProductIntensity = $(thisProductIntensity).filter(function (itm, i, a) {
            return (i = $.inArray(itm, a));
          });
          len = thisProductIntensity.length;
          for (i = 0; i < len; i++) {
            if ($.inArray(thisProductIntensity[i], site.mpp_filter.concernArr) == -1) {
              $(prodBox).addClass(thisProductIntensity[i]);
              site.mpp_filter.concernArr.push(thisProductIntensity[i]);
            }
          }

          //
          //    Add COVERAGE
          //
          if (
            product.ATTRIBUTE_COVERAGE !== null &&
            $.inArray(thisCatId, site.mpp_filter.showCoverage) > -1
          ) {
            arr = product.ATTRIBUTE_COVERAGE.split(',');
            $.each(arr, function (index, value) {
              val = value.replace(/^\s+|\s+$/g, ''); // trim() that works with IE8
              val = val.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');
              $(prodBox).addClass(val);
              if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
                site.mpp_filter.concernArr.push(val);
              }
            });
          }

          //
          //    Add COLLECTION
          //
          if (
            product.ATTRIBUTE_COLLECTION !== null &&
            $.inArray(thisCatId, site.mpp_filter.showCollections) > -1
          ) {
            val = product.ATTRIBUTE_COLLECTION.toLowerCase().replace(/[^A-Za-z0-9_]/g, '_');

            // fix collection mappings
            switch (val) {
              case 'pure_color_envy_shine':
                val = 'pure_color';
                break;
              case 'pure_color_envy':
                val = 'pure_color';
                break;
            }

            $(prodBox).addClass(val);
            if ($.inArray(val, site.mpp_filter.concernArr) == -1) {
              site.mpp_filter.concernArr.push(val);
            }
          }
        });
    },
    // end showConcernedArr

    //
    //    FILTER PRODUCTS
    //
    //      Okay, this gets a little complicated. Hang on.
    //
    //      STEP ONE.
    //      Within each attribute, e.g., Skin Type, Skin Concern, Collection,
    //      users can select multiple options, and those are treated as OR.
    //
    //      Example:
    //        In the Skin Type attribute, a user selects "Dry", "Oily", and "Normal".
    //        All products that have EITHER "Dry" OR "Oily" OR "Normal" are shown.
    //        So every time a user selects an option within the same attribute, the number
    //        of products increases.
    //
    //      So in the first step, we look at all the attributes (there can be different numbers
    //      and different kinds of attributes). Each attribute gets its own set of products.
    //      That is, we pretend that only that attribute exists, and create a selector that
    //      would display only the user-selected products.
    //
    //      Clear as mud? Check out the example.
    //
    //      Example:
    //        There are three attributes: Skin Care, Skin Concern, and Collection.
    //        The user has selected a few filters in each attribute.
    //        In the Skin Care attribute, the user has selected "Dry" and "Normal".
    //        The code ignores the existance of other two attributes and creates a selector
    //        that shows all the "Dry" and "Normal" products:
    //          "li.mpp__product.dry, li.mpp__product.normal"
    //            (in real life skin types are done with 'type-'+number, so the real selector would be:
    //            "li.mpp__product.type-2, li.mpp__product.type-3")
    //
    //          selector[0] = "li.mpp__product.type-2, li.mpp__product.type-3"
    //          selector[1] = "li.mpp__product.wrinkles, li.mpp__product.redness"
    //          selector[2] = "li.mpp__product.daywear, li.mpp__product.nutritious"
    //
    //
    //      STEP TWO.
    //
    //      prods = $(selector[0]).filter(selector[1]).filter(selector[2])
    //
    //
    filterProducts: function () {
      //
      //  Find out number of attributes
      //
      var numAttributes = $('.mpp__filter-section').length;
      var selector;
      var prods = [];
      var className;
      var selectedFilters = [];
      var $currentAttribute;
      var currentFilter;

      //
      //    Find out which filters in this attribute have been selected
      //      and put them in "activeParams"
      //
      for (var i = 0; i < numAttributes; i++) {
        selectedFilters = [];
        $currentAttribute = $('.mpp__filter-section').eq(i);

        $currentAttribute.find('li.mpp__filter-item a.active').each(function () {
          selectedFilters.push($(this).parent().attr('class'));
        });

        //
        //    Create product set based on the selected filters
        //
        for (var j = 0; j < selectedFilters.length; j++) {
          selector = 'li.mpp__product.na';

          currentFilter = selectedFilters[j]; // this will be something like "mpp__filter-item type-3"

          for (var k = 1; k < currentFilter.split(' ').length; k++) {
            className = currentFilter.split(' ')[k];
            if (typeof className != 'undefined') {
              className = className.replace(/^\s+|\s+$/g, ''); // trim() for IE8
              if (className.length > 0) {
                selector += ', li.mpp__product.' + className;
              }
            }
          }

          //
          //    Based on the selector, build the set of products that should be displayed
          //
          var newProds = $(selector);

          if (typeof prods[i] === 'undefined') {
            prods[i] = newProds;
          } else {
            prods[i] = $.merge(prods[i], newProds);
          }

          //
          //    If there are no selected filters, then show all the products
          //
          if (selectedFilters[j].length === 0) {
            $('li.mpp__product').removeClass('hidden');
          }
        }
      }

      //
      //    At this point, we have X sets of products, one set for every attribute.
      //    It's time to filter those in order to create a final set of filtered products
      //
      var $prodsToShow = $('.mpp__product');

      $.each(prods, function (index, prodSet) {
        if (typeof prodSet !== 'undefined') {
          $prodsToShow = $prodsToShow.filter(prodSet);
        }
      });

      $('li.mpp__product').addClass('hidden');
      $prodsToShow.removeClass('hidden');
    },

    //
    //    Create a matrix that says whether the intersection of two filter classes,
    //    e.g., "Dry" and "Blemishes" result in zero products or not.
    //
    //    Examples:
    //      matrix["dry"]["blemishes"] = true                           : this means there are zero products
    //      matrix["normal_combination"]["enlarged_pores"] = false      : this means there one or more products
    //
    createZeroProductFilterMatrix: function () {
      var matrix = {};
      var $visibleProducts = $('.mpp__product');
      var numFilters = site.mpp_filter.concernArr.length;

      for (var i = 0; i < numFilters; i++) {
        var filter1 = site.mpp_filter.concernArr[i];

        matrix[filter1] = {};

        for (var j = 0; j < numFilters; j++) {
          var filter2 = site.mpp_filter.concernArr[j];

          // default value, assumes no products
          //
          matrix[filter1][filter2] = true;

          //  Loop over all products
          //  See if there are any products that share the classes (i.e., filters) we're looking at
          //
          $.each($visibleProducts, function (index, value) {
            if ($(value).hasClass(filter1) && $(value).hasClass(filter2)) {
              matrix[filter1][filter2] = false; // this means that there's at least one product with both those filters

              return false; // we have our answer, and it's time to look at the next filter
            }
          });
        }
      }

      return matrix;
    }, // end createZeroProductFilterMatrix

    greyOutZeroResultFilters: function () {
      var $filtersInAttribute;
      var $filtersToExamine;
      var filterClassName;
      var $activeFiltersInLoopAttribute;
      var thisFilterClassArr;
      var thisFilterClass;
      var activeFilterClass;
      var $loopAttributes;
      var hasZero;
      var thisAttributeIsAllTrue;
      var anyAttributeIsAllTrue;
      var selectedFilter = site.mpp_filter.lastFilterClicked.name;
      var $attributes = $('#mpp__filter .mpp__filter-section');
      var $currentAttribute = $('.mpp__filter-section').has(
        'li.mpp__filter-item.' + selectedFilter
      );
      var currentAttributeIndex = $('.mpp__filter-section').index($currentAttribute);
      var $attributesExceptCurrent = $('.mpp__filter-section').not(
        ':eq(' + currentAttributeIndex + ')'
      );
      var numSelectedFiltersInCurrentAttribute = $currentAttribute.find(
        'li.mpp__filter-item a.active'
      ).length;
      var $normalFiltersToExamine = $('#mpp__filter li.mpp__filter-item').not(
        '.js-inactive, .zero-results, :has(a.active)'
      );
      var $greyedOutFilters = $('#mpp__filter li.mpp__filter-item.zero-results');
      var greyedOutFilterClass;
      var greyedOutFilterAttr;

      //
      //  SCENARIO 1: USER SELECTS FIRST FILTER IN AN ATTRIBUTE
      //
      //      Skin Types
      //      ---------------
      //      [x] Dry                       <-- selected
      //      [ ] Normal/Combination
      //      [ ] Oily
      //
      //  IF
      //    this is the only selected filter in the attribute
      //      AND
      //    this filter is selected (instead of deselected)
      //  THEN
      //    grey out filters (not in current attribute) with zero products
      //
      //  COMPLICATION:
      //    -   You have to look at other attributes as a whole. That is, if the combined active (selected) filters
      //        in an attribute all result in zero products for a given non-active filter, then that filter
      //        must be greyed out.
      //
      if (
        numSelectedFiltersInCurrentAttribute === 1 &&
        site.mpp_filter.lastFilterClicked.selected
      ) {
        //
        //  v2:
        //        if all the active filters in an attribute have a [][] results of true,
        //        that means that attribute's selection keep that grey-out filter greyed out
        //        because attributes act as AND (i.e., subtractive)

        //
        //    For all NORMAL filters NOT in current attribute
        //
        $filtersToExamine = $attributesExceptCurrent
          .find('.mpp__filter-item')
          .not('.js-inactive, .zero-results, :has(a.active)');

        //
        //      For each non-greyed-out filter, look at the active filters in the other attributes
        //
        $.each($filtersToExamine, function (filterIndex, filterValue) {
          filterClassName = site.mpp_filter.getClassFromFilterLineItem($(filterValue));
          $loopAttributes = $('.mpp__filter-section').not(
            ':has(li.mpp__filter-item.' + filterClassName + ')'
          );

          //
          //    Loop over all attributes not containing the current filter class
          //
          $.each($loopAttributes, function (loopAttributeIndex, loopAttributeValue) {
            thisAttributeIsAllTrue = true;
            $activeFiltersInLoopAttribute = $(loopAttributeValue).find(
              '.mpp__filter-item:has(a.active)'
            );

            if ($activeFiltersInLoopAttribute.length === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              //
              //  Loop over those active filters
              //
              $.each(
                $activeFiltersInLoopAttribute,
                function (activeFilterIndex, activeFilterValue) {
                  activeFilterClass = site.mpp_filter.getClassFromFilterLineItem(
                    $(activeFilterValue)
                  );
                  hasZero =
                    site.mpp_filter.zeroProductFilterMatrix[filterClassName][activeFilterClass];
                  if (!hasZero) {
                    thisAttributeIsAllTrue = false;

                    return false; // we don't need to look in this attribute any more
                  }
                }
              );
            }

            if (thisAttributeIsAllTrue) {
              $(filterValue).addClass('zero-results');
            }
          });
        });

        //
        //  SCENARIO 2: USER *DE*SELECTS ONLY FILTER IN AN ATTRIBUTE
        //
        //  IF
        //    this was the only selected filter in the attribute
        //      AND
        //    this filter is deselected (instead of selected)
        //  THEN
        //    see if any greyed-out filters can be un-greyed-out (i.e., returned to normal)
        //
        //   The only thing that would cause a grey-out filter to remain greyed-out would be the action of
        //    another active filter.
        //
        //      1. Loop over list of filters that COULD cause greying out (i.e., active ones).
        //      2. IF a filter (say, "double_wear") is selected, then it MIGHT be causing the greying out of, say, "blemishes".
        //      3. In order for a grey-out filter to remain grey-out, ALL ACTIVE filters must have no intersection
        //         with the grey-out filter.
        //          - that is:
        //          site.mpp_filter.zeroProductFilterMatrix[grey-out filter][active filter] = true
        //          for ALL ACTIVE FILTERS
        //          If even one active filter is "false" above, the greyed-out filter reverts to normal
        //
        //  Example:
        //
        //      Skin Types
        //      ---------------
        //      [ ] Dry                       <-- deselected
        //      [ ] Normal/Combination
        //      [ ] Oily
        //
      } else if (
        numSelectedFiltersInCurrentAttribute === 0 &&
        !site.mpp_filter.lastFilterClicked.selected
      ) {
        //
        //  loop over all grey-ed out filters
        //
        //    loop over all attributes except current one
        //
        //      loop over all active filters in an attribute
        //
        //        if all the active filters in that attribute have a [][] results of true,
        //        that means that attribute's selection keep that grey-out filter greyed out
        //        because attributes act as AND (i.e., subtractive)
        //

        // $greyedOutFilters = $("#mpp__filter li.mpp__filter-item.zero-results");
        // $attributesExceptCurrent = $(".mpp__filter-section").not(":eq(" + currentAttributeIndex + ")");

        //
        //    Loop over all greyed-out filters
        //
        $.each($greyedOutFilters, function (greyedOutIndex, greyedOutValue) {
          greyedOutFilterClass = site.mpp_filter.getClassFromFilterLineItem($(greyedOutValue));
          anyAttributeIsAllTrue = false;

          $.each($('.mpp__filter-section'), function (attrIndex, attrValue) {
            // if the greyed-out attribute and the active filter are in the same attribute
            // they shouldn't be compared to each other
            //
            greyedOutFilterAttr = $(greyedOutValue).closest('.mpp__filter-section');
            if (greyedOutFilterAttr.is($(attrValue))) {
              return true;
            }

            thisAttributeIsAllTrue = true;
            $activeFiltersInLoopAttribute = $(attrValue).find('.mpp__filter-item:has(a.active)');

            if ($activeFiltersInLoopAttribute.length === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              //
              //  Loop over those active filters
              //
              $.each(
                $activeFiltersInLoopAttribute,
                function (activeFitlerIndex, activeFilterValue) {
                  activeFilterClass = site.mpp_filter.getClassFromFilterLineItem(
                    $(activeFilterValue)
                  );
                  hasZero =
                    site.mpp_filter.zeroProductFilterMatrix[greyedOutFilterClass][
                      activeFilterClass
                    ];

                  if (!hasZero) {
                    thisAttributeIsAllTrue = false;

                    return false; // we don't need to look in this attribute any more
                  }
                }
              ); // end loop over active filters
            }

            if (thisAttributeIsAllTrue) {
              anyAttributeIsAllTrue = true;

              return true;
            }
          }); // end loop over attributes

          if (!anyAttributeIsAllTrue) {
            $(greyedOutValue).removeClass('zero-results');
          }
        });

        //
        //  SCENARIO 3:
        //    USER SELECTS SECOND OR MORE FILTER IN AN ATTRIBUTE
        //
        //    We now look for greyed-out options to UN-grey-out
        //    IN OTHER ATTRIBUTES
        //
        //  Example:
        //
        //      Skin Types
        //      ---------------
        //      [x] Dry
        //      [x] Normal/Combination      <-- selected
        //      [ ] Oily
        //
      } else if (
        numSelectedFiltersInCurrentAttribute >= 1 &&
        site.mpp_filter.lastFilterClicked.selected
      ) {
        // $greyedOutFilters = $("#mpp__filter li.mpp__filter-item.zero-results");
        selectedFilter = site.mpp_filter.lastFilterClicked.name;
        $currentAttribute = $('.mpp__filter-section').has('li.mpp__filter-item.' + selectedFilter);

        //
        //    Loop over all greyed-out filters
        //
        $.each($greyedOutFilters, function (index, value) {
          $loopAttribute = $(value).closest('.mpp__filter-section');
          if ($loopAttribute.is($currentAttribute)) {
            return true; // same as "continue" in loops
          }

          greyedOutFilterClass = site.mpp_filter.getClassFromFilterLineItem($(value));
          //
          //    If there's an intersection of the user-selected filter and the greyed-out filter,
          //    un-grey-out the filter.
          //
          if (!site.mpp_filter.zeroProductFilterMatrix[selectedFilter][greyedOutFilterClass]) {
            $(value).removeClass('zero-results');

            return true; // same as continue
          }
        });
        //
        //  SCENARIO 4:
        //    USER *DE*SELECTS SECOND OR MORE FILTER IN AN ATTRIBUTE
        //
        //    This might INCREASE the number of greyed-out options.
        //
        //    Method: Go over all non-greyed-out, non-selected filters (outside the current attribute)
        //    and see if they should be greyed out.
        //
        //    For each non-greyed-out, non-selected filter (i.e., normal state):
        //    - compare that filter to all the active filters that aren't in that filter's own attribute
        //
        //
        //  Example:
        //
        //      Skin Types
        //      ---------------
        //      [x] Dry
        //      [ ] Normal/Combination      <-- deselected
        //      [ ] Oily
        //
      } else if (
        numSelectedFiltersInCurrentAttribute >= 0 &&
        !site.mpp_filter.lastFilterClicked.selected
      ) {
        //
        //    Loop over all non-greyed-out, non-selected filters outside current attribute
        //
        //      For each of those "normal" filters, loop over attributes outside of that normal filter's attribute
        //
        //        For each attribute, loop over all of that attribute's active filters
        //
        //           If
        //            ALL of those attribute's active filters result in [normal][active] = true
        //           THEN
        //            thisAttributeIsAllTrue = true
        //           ELSE
        //            thisAttributeIsAllTrue = false
        //
        //              Which means
        //                anyAttributeIsAllTrue = false
        //
        //          If anyAttributeIsAllTrue,
        //            that means there's an attribute whose selections (i.e., active filters) whose existence will force a grey-out
        //            of the "normal" filter
        //
        //
        //
        //

        $.each($normalFiltersToExamine, function (normalFilterIndex, normalFilterValue) {
          $normalFiltersAttribute = $(normalFilterValue).closest('.mpp__filter-section');
          anyAttributeIsAllTrue = false;
          normalFilterClass = site.mpp_filter.getClassFromFilterLineItem($(normalFilterValue));

          //
          //    Loop over all attributes
          //
          $.each($('.mpp__filter-section'), function (attrIndex, attrValue) {
            thisAttributeIsAllTrue = true;

            //
            //  If the loop's attribute is the same as the normalFilter's attribute, skip to the next attribute
            //
            if ($normalFiltersAttribute.is($(attrValue))) {
              return true; // continue to next loop value
            }

            $thisAttrActiveFilters = $(attrValue).find('.mpp__filter-item:has(a.active)');

            if ($thisAttrActiveFilters.length === 0) {
              thisAttributeIsAllTrue = false;
            } else {
              $.each($thisAttrActiveFilters, function (activeFilterIndex, activeFilterValue) {
                //
                //    See if the [][] combination of the normalFilter and the activeFilter
                //
                activeFilterClass = site.mpp_filter.getClassFromFilterLineItem(
                  $(activeFilterValue)
                );
                hasZero =
                  site.mpp_filter.zeroProductFilterMatrix[normalFilterClass][activeFilterClass];
                if (!hasZero) {
                  thisAttributeIsAllTrue = false;

                  return false; // we don't need to look at this attribute any more
                }
              }); // end active filter loop
            }

            if (thisAttributeIsAllTrue) {
              anyAttributeIsAllTrue = true;

              return true;
            }
          }); // end attribute loop

          if (anyAttributeIsAllTrue) {
            $(normalFilterValue).addClass('zero-results');
          }
        });
      }
    },

    //
    //    Get a filter class like "dry" or "lines_and_wrinkles" from a DOM element
    //
    getClassFromFilterLineItem: function (filterElement) {
      var thisFilterClassArr = $(filterElement).attr('class').split(' ');

      thisFilterClassArr = $.grep(thisFilterClassArr, function (value) {
        return value != 'mpp__filter-item' && value != 'zero-results';
      });

      return thisFilterClassArr[0];
    },

    setVisibleItemCount: function () {
      var numProducts = $('.mpp__product-grid li.mpp__product').not('.hidden').length;

      $('#mpp__filter-footer .js-item-count').html(numProducts);

      //
      //    Correct grammar
      //
      if (numProducts === 1) {
        $('#mpp__filter-footer .js-product').show();
        $('#mpp__filter-footer .js-products').hide();
      } else {
        $('#mpp__filter-footer .js-products').show();
        $('#mpp__filter-footer .js-product').hide();
      }
    },

    scrollToTopOfFilter: function () {
      $('html, body').animate({ scrollTop: $('.mpp.js-mpp-wrapper').offset().top - 80 }, 'slow');
    },

    //
    //    Any of the attributes have too many filters in them.
    //      If so, create another column and move the extra filters there
    //
    createSecondColumnForAttributesIfNeeded: function () {
      var numFiltersInAttribute;
      var $allSections = $('#mpp__filter .mpp__filter-section');
      // if the window is too small, and there are already 3 attributes,
      //    do not create an extra column
      var filterWidth = $('#mpp__filter').width();
      var numAttributes = $('.mpp__filter-section').length;

      if (filterWidth <= 800 && numAttributes >= 3) {
        return false;
      }
      // console.log("*** filter width", filterWidth);

      $.each($allSections, function (attrIndex, attrValue) {
        numFiltersInAttribute = $(attrValue).find('li.mpp__filter-item:not(.hidden)').length;

        if (numFiltersInAttribute > site.mpp_filter.maxNumberFiltersPerColumn) {
          //
          //  Create second column for attribute
          //
          newList = document.createElement('ul');
          $(newList).addClass('added-column');
          $(attrValue).append(newList);
          startFilterNum = site.mpp_filter.maxNumberFiltersPerColumn;
          $theFilters = $(attrValue)
            .find('li.mpp__filter-item:not(.hidden)')
            .slice(startFilterNum, numFiltersInAttribute);
          $theFilters.detach().appendTo($(newList));
        }
      });
    },

    adjustMppProductGrid: function () {
      var $visibleProducts = $('.mpp__product-grid li.mpp__product').not('.hidden');

      //
      //  1. Remove all classes that determine side margins
      //
      $('.mpp__product-grid li.mpp__product').removeClass('nth-child-3np2 middle left');

      //
      //    2.  Add "middle" and "left" classes to layout new product list correctly
      //
      $.each($visibleProducts, function (prodIndex, prodValue) {
        //
        //  prodIndex % 3 will be 0 , 1, 2, so 1 will be the middle product
        //
        if (prodIndex % 3 === 1) {
          $(prodValue).addClass('middle');
        } else if (prodIndex % 3 === 0) {
          $(prodValue).addClass('left');
        }
      });
    },

    //
    //    Based on the number of attributes and the number of columns in each attribute,
    //    adjust the width of those attributes and the columns in them.
    //
    adjustColumnWidths: function () {
      //
      //    Reset $allSections because we've just removed the empty ones
      //
      $allSections = $('#mpp__filter .mpp__filter-section');
      numAllSections = $allSections.length;
      $allSectionsUL = $('#mpp__filter .mpp__filter-section ul');
      numAllSectionsUL = $allSectionsUL.length;

      if (numAllSections === numAllSectionsUL) {
        if (numAllSections >= 4) {
          $allSections.addClass('four-columns');
        } else {
          $allSections.addClass('three-columns');
        }
      } else if (numAllSections < numAllSectionsUL) {
        if (numAllSectionsUL >= 4) {
          $allSections.addClass('four-columns');
          $allSectionsUL.addClass('four-columns');
        } else {
          $allSections.addClass('three-columns');
          $allSectionsUL.addClass('three-columns'); // this is the default size, even if there are only 1 or 2 columns
        }

        // if a section has 2 ULs, add "double-" to that section's class
        //  so it's wide enough to accommodate both ULs
        //
        $.each($allSections, function (sectionIndex, sectionValue) {
          if ($(sectionValue).find('ul').length == 2) {
            if ($(sectionValue).hasClass('four-columns')) {
              $(sectionValue).removeClass('four-columns').addClass('double-four-columns');
            } else {
              $(sectionValue).removeClass('three-columns').addClass('double-three-columns');
            }
          }
        });
      }
    }
  };
  //
  //    END site.mpp_filter

  Drupal.behaviors.mpp_filter = {
    attach: function (context, settings) {
      var doABtesting = true;

      if (doABtesting) {
        var evarData = '';

        if (sessionStorage.splitTest == null) {
          if (Math.random() >= 0.5) {
            evarData = 'MPP Filter Test | Version A | MPP Filters Hidden';
            $('#mpp__filter-tab').addClass('hidden');
            sessionStorage.splitTest = true;
          } else {
            evarData = 'MPP Filter Test | Version B | MPP Filters Shown';
            site.mpp_filter.init();
            sessionStorage.splitTest = false;
          }
        } else if (sessionStorage.splitTest == 'false') {
          evarData = 'MPP Filter Test | Version B | MPP Filters Shown';
          site.mpp_filter.init();
        } else if (sessionStorage.splitTest == 'true') {
          evarData = 'MPP Filter Test | Version A | MPP Filters Hidden';
          $('#mpp__filter-tab').addClass('hidden');
        }
      }

      $(window).on('load', function () {
        $(window).trigger('event24', { evar32: evarData });
      });
    } // close attach property
  }; // close Drupal.behaviors.mpp_filter
})(jQuery);
